export const FormLabel = {
  defaultProps: {
    marginBottom: 0,
  },
}
